import {
  PERMISSIONS,
  ROLE_PERMISSIONS,
  type PermissionValue,
  type UserRoleValue,
} from "@/constants";

/**
 * Does this role hold this permission? The single rule behind
 * authStore.hasPermission, useCan, ProtectedRoute and the sidebar.
 * super_user holds the wildcard, as on the server (commons.rbac).
 */
export const roleHasPermission = (
  role: UserRoleValue | null | undefined,
  permission: PermissionValue | string,
): boolean => {
  if (!role) return false;
  const granted: readonly string[] = ROLE_PERMISSIONS[role] ?? [];
  return granted.includes(PERMISSIONS.ALL) || granted.includes(permission);
};
